export var ShortUnitId;
(function (ShortUnitId) {
    ShortUnitId["None"] = "none";
    ShortUnitId["K"] = "K";
    ShortUnitId["M"] = "M";
    ShortUnitId["B"] = "B";
    ShortUnitId["T"] = "T";
})(ShortUnitId || (ShortUnitId = {}));
export var numberFormatUnits = [
    {
        id: ShortUnitId.None,
        divisor: 1,
        display: "",
    },
    {
        id: ShortUnitId.K,
        divisor: 1000,
        display: "K",
    },
    {
        id: ShortUnitId.M,
        divisor: 1000 * 1000,
        display: "M",
    },
    {
        id: ShortUnitId.B,
        divisor: 1000 * 1000 * 1000,
        display: "B",
    },
    {
        id: ShortUnitId.T,
        divisor: 1000 * 1000 * 1000 * 1000,
        display: "T",
    },
];
//# sourceMappingURL=numbers.js.map